/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
export const replaceArray = (target, newValues) => target.splice.apply(target, [0, target.length].concat(newValues));

export const appendToArray = (target, ...arrays) => target.splice.apply(target, Array.prototype.concat.apply([target.length, 0], arrays));

/**
 * Delete the first element which passes the predicate truth test from the given array
 * @param {array} arr
 * @param {function} predicate predicate used to test each element
 * @returns {number} index of the element got delete, if no element got deleted return -1
 */
export const deleteFromArray = (arr, predicate) => {
	let i;
	for(i = 0; i < arr.length; i++){
		if(predicate(arr[i])) {
			break;
		}
	}
	if(i < arr.length){
		arr.splice(i, 1);
		return i;
	} else {
		return -1;
	}
};
/**
 * Finds the intersection array between two arrays
 * example: [1,2,3] vs [1,3]. the returned result is [1,3]
 * [1,1,2] and [1] should return [1]
 * @param {Array} array1 
 * @param {Array} array2
 * @returns {Array}
 */
export const intersectArrays = (array1, array2) => {
	return array1.filter((element) => {
		return array2.indexOf(element) > -1;
	}).filter((element, index, c) => { // extra step to remove duplicates
		return c.indexOf(element) === index;
	});
};



// WEBPACK FOOTER //
// ./src/js/util/ArrayOperations.js